import { render, staticRenderFns } from "./avatarUpload.vue?vue&type=template&id=6211bba6&scoped=true"
import script from "./avatarUpload.vue?vue&type=script&lang=js"
export * from "./avatarUpload.vue?vue&type=script&lang=js"
import style0 from "./avatarUpload.vue?vue&type=style&index=0&id=6211bba6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6211bba6",
  null
  
)

export default component.exports